__turbopack_context__.v({
  "cardWrapper": "BlockCarouselShowcaseWithCard-module-scss-module__KrE9oG__cardWrapper",
  "cards": "BlockCarouselShowcaseWithCard-module-scss-module__KrE9oG__cards",
  "fade-in": "BlockCarouselShowcaseWithCard-module-scss-module__KrE9oG__fade-in",
  "flushBottom": "BlockCarouselShowcaseWithCard-module-scss-module__KrE9oG__flushBottom",
  "flushTop": "BlockCarouselShowcaseWithCard-module-scss-module__KrE9oG__flushTop",
  "inner": "BlockCarouselShowcaseWithCard-module-scss-module__KrE9oG__inner",
  "nav": "BlockCarouselShowcaseWithCard-module-scss-module__KrE9oG__nav",
  "navCount": "BlockCarouselShowcaseWithCard-module-scss-module__KrE9oG__navCount",
  "navItem": "BlockCarouselShowcaseWithCard-module-scss-module__KrE9oG__navItem",
  "navWrapper": "BlockCarouselShowcaseWithCard-module-scss-module__KrE9oG__navWrapper",
  "navWrapper-cream": "BlockCarouselShowcaseWithCard-module-scss-module__KrE9oG__navWrapper-cream",
  "root": "BlockCarouselShowcaseWithCard-module-scss-module__KrE9oG__root",
  "slides": "BlockCarouselShowcaseWithCard-module-scss-module__KrE9oG__slides",
});
